import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("tl_token") || "");
  const [user, setUser] = useState(null);
  const [modules, setModules] = useState([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      if (token) {
        try {
          const r = await api.get("/auth/me");
          setUser(r.data.user);
          setModules(r.data.modules);
        } catch {
          localStorage.removeItem("tl_token");
          setToken("");
        }
      }
      setReady(true);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("tl_token", r.data.token);
    if (r.data.user.role !== "admin" && r.data.user.company_id) {
      localStorage.setItem("tl_company", r.data.user.company_id);
    }
    setToken(r.data.token);
    setUser(r.data.user);
    setModules(r.data.modules);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("tl_token");
    localStorage.removeItem("tl_company");
    setToken("");
    setUser(null);
    setModules([]);
  };

  return (
    <AuthContext.Provider value={{ token, user, modules, ready, login, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};
